import { render } from "./Theory.vue?vue&type=template&id=05b3ade1&bindings={\"sections\":\"data\",\"shouldPlaySoundscape\":\"data\",\"audioIsPlaying\":\"options\",\"audioIsPaused\":\"options\",\"throttle\":\"options\",\"onScroll\":\"options\",\"getScrollPoint\":\"options\",\"formatWithCommas\":\"options\",\"calcRowOpacity\":\"options\"}"
import script from "./Theory.vue?vue&type=script&lang=js"
export * from "./Theory.vue?vue&type=script&lang=js"

import "./Theory.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script